<template>
  <div>
    <h3 class="title">
      <span>推广好友返利</span>
    </h3>
    <div class="cash">
      <div class="name">推荐收益：</div>
      <div class="infos">
        <em>¥{{obj.extend_all}}</em>
        <router-link tag="span" :to="{path:'/orderview/mypays',query:{index:1}}">去提现</router-link>
      </div>
      <div class="clear"></div>
    </div>
    <div class="cash">
      <div class="name">已推荐好友：</div>
      <div class="infos">
        <em class="on">{{obj.extend_user}}</em>名
      </div>
      <div class="clear"></div>
    </div>
    <div class="cash">
      <div class="name">已推荐返利订单：</div>
      <div class="infos">
        <em class="on">{{obj.extend_orders}}</em>单
      </div>
      <div class="clear"></div>
    </div>
    <div class="cash">
      <div class="name">推广链接：</div>
      <div class="infos">
        <input type="text" :value="obj.extend_url" readonly id="copy" class="inputbox fl" />
        <i class="el-icon-document-copy fl" @click="copy"></i>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
    <div class="cash">
      <div class="name on">分享推广链接：</div>
      <div class="infos">
        <share :config="config" class="fr"></share>
      </div>
      <div class="clear"></div>
    </div>

    <h3 class="title">
      <span class="fl">推广好友</span>
      <router-link :to="{path:'/orderview/extendfriends',query:{index:3}}" tag="em" class="fr">
        查看全部
        <i class="el-icon-arrow-right"></i>
      </router-link>
      <div class="clear"></div>
    </h3>
    <el-table :data="tuanduiobjs.arr" style="width: 100%" class="tablebox">
      <el-table-column prop="title" label="会员账号" width="232"></el-table-column>
      <el-table-column prop="date" label="注册日期" width="232"></el-table-column>
      <el-table-column prop="extend_orders" label="返现订单数量" width="232"></el-table-column>
      <el-table-column prop="extend_user" label="推荐人数" width="232">
        <template slot-scope="scope">
          <router-link
            tag="div"
            :to="{path:'/orderview/extendfriends',query:{index:3,id:scope.row.id}}"
          >{{scope.row.extend_user}}</router-link>
        </template>
      </el-table-column>
    </el-table>

    <h3 class="title">
      <span class="fl">已推荐返利订单</span>
      <router-link :to="{path:'/orderview/extendorder',query:{index:3}}" tag="em" class="fr">
        查看全部
        <i class="el-icon-arrow-right"></i>
      </router-link>
      <div class="clear"></div>
    </h3>

    <el-table :data="orderobj.arr" style="width: 100%" class="tablebox">
      <el-table-column prop="order_num" label="订单号" width="310"></el-table-column>
      <el-table-column prop="money" label="返利金额" width="310"></el-table-column>
      <el-table-column prop="date" label="返利时间" width="310"></el-table-column>
    </el-table>

    <h3 class="title">
      <span class="fl">推荐返利账户明细</span>
      <router-link :to="{path:'/orderview/extenddetailed',query:{index:3}}" tag="em" class="fr">
        查看全部
        <i class="el-icon-arrow-right"></i>
      </router-link>
      <div class="clear"></div>
    </h3>
    <el-table :data="orderobj.arr" style="width: 100%" class="tablebox">
      <el-table-column prop="date" label="时间" width="232"></el-table-column>
      <el-table-column prop="content" label="内容" width="232"></el-table-column>
      <el-table-column prop="money" label="金额" width="232"></el-table-column>
      <el-table-column prop="title" label="备注" width="232">
        <template slot-scope="scope">
          <div>{{scope.row.title | starfilters}}</div>
          <div>{{scope.row.title | endfilters}}</div>
        </template>
        <div></div>
      </el-table-column>
    </el-table>
    <h3 class="title">
      <span>推荐返利规则</span>
    </h3>
    <p>
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容
      推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容推荐返利规则内容。
    </p>
    <router-view></router-view>
  </div>
</template>

<script>
import utilFile from "@/ace/ace.js";
import { Input, Table, TableColumn, Message } from "element-ui";
export default {
  components: {
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Message.name]: Message
  },
  data() {
    return {
      obj: {},
      page: 1,
      tableData: [],
      tuanduiobjs: {},
      orderobj: {},
      input: "",
      config: {
        sites: ["wechat", "weibo", "qq"], // 启用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper:
          "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>"
      }
    };
  },
  filters: {
    starfilters(data) {
      var sub = data.slice(4, -4);

      return sub;
    },
    endfilters(data) {
      var sub;
      if(data.indexOf("级收入") != -1){
        sub = data.substring(data.length - 4);
      }else{
        sub = ' ';
      }
      return sub;
    }
  },
  methods: {
    distributionfunc() {
      this.$axios({
        method: "post",
        url: `/api/extend.myExtend`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let obj = JSON.parse(utilFile.decrypt(res.data.data));
        this.obj = obj;
      });
    },
    copy() {
      //复制分享链接
      var Url2 = document.getElementById("copy");
      Url2.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      Message.closeAll();
      Message({
        showClose: true,
        message: "复制成功",
        type: "success"
      });
    },
    tuandui() {
      var data = utilFile.encrypt(
        JSON.stringify({
          page: this.page
        })
      );
      this.$axios({
        method: "post",
        url: `/api/extend.myExtendList?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.data != undefined) {
          let arr = JSON.parse(utilFile.decrypt(res.data.data));
          this.tuanduiobjs = arr;
        }
      });
    },
    order() {
      var data = utilFile.encrypt(
        JSON.stringify({
          page: this.page
        })
      );
      this.$axios({
        method: "post",
        url: `/api/extend.myExtendOrder?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.data != undefined) {
          let arr = JSON.parse(utilFile.decrypt(res.data.data));

          this.orderobj = arr;
        }
      });
    },
    user() {
      this.$axios({
        method: "post",
        url: `/api/user.infomation`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        } else {
          let userinfo = JSON.parse(utilFile.decrypt(res.data.data));
        }
      });
    }
  },
  mounted() {
    this.distributionfunc();
    this.tuandui();
    this.order();
    this.user();
  }
};
</script>

<style scoped>
h3.title {
  font-size: 16px;
  color: #000;
  padding-bottom: 20px;
  border-bottom: 1px solid #edf1f2;
  margin-bottom: 20px;
  margin-top: 26px;
  font-weight: 600;
}

h3.title span {
  box-sizing: border-box;
  padding-left: 13px;
  border-left: 5px solid #38a0ff;
}

h3.title em {
  font-size: 16px;
  color: #38a0ff;
  cursor: pointer;
}
.cash .name {
  float: left;
  font-size: 14px;
  color: #898989;
  line-height: 23px;
  min-width: 120px;
}

.cash .name.on {
  line-height: 34px;
}

.cash .infos {
  float: left;
  font-size: 14px;
  line-height: 23px;
  margin-bottom: 23px;
}

.cash .infos em {
  color: #ff0000;
  font-weight: bold;
}
.cash .infos em.on {
  color: #38a0ff;
}
.cash .infos span {
  display: inline-block;
  font-size: 12px;
  line-height: 23px;
  padding: 0 8px;
  border-radius: 3px;
  background-color: #ff4e24;
  color: #fff;
  margin-left: 16px;
  cursor: pointer;
}

.cash .infos i {
  color: #38a0ff;
  line-height: 23px;
  font-size: 20px;
}

p {
  font-size: 14px;
  color: #000;
  line-height: 1.5em;
}

.tablebox {
  margin-bottom: 38px;
  cursor: pointer;
}
</style>
<style>
.inputbox {
  height: 23px;
  line-height: 23px;
  display: inline-block;
  width: auto !important;
  background-color: transparent;
  margin-right: 10px;
}

.inputbox .el-input__inner {
  height: 23px;
  line-height: 23px;
  background-color: transparent;
  border: 0;
  padding: 0;
}

.inputbox.el-input.is-disabled .el-input__inner {
  background-color: transparent;
  border: 0;
}

.inputbox i {
  cursor: pointer;
}

.tablebox.el-table th {
  text-align: center;
  background-color: #f5f5f5;
  font-weight: 500;
  color: #000000;
}

.tablebox.el-table td {
  text-align: center;
}

.cash .social-share .social-share-icon {
  margin-top: 0;
  margin-bottom: 0;
}
</style>